<template>
  <div class="inline-auth-panel tabbed sm">
    <internal-nav
        class="tabs uc no-ul tighter"
        :active-item="mode ? mode === 'forgot_password' ? 'login' : mode : 'login'"
        :items="navItems"
        @select="changeAuthMode"
    ></internal-nav>
    <div class="content-panes">
      <auth-login
          :class="{active: mode === 'login'}"
          :inline="true"
          @loggedIn="$emit('authed')"
      ></auth-login>
      <auth-signup
          :class="{active: mode === 'signup'}"
          :inline="true"
          @signedUp="$emit('authed')"
      ></auth-signup>
      <auth-forgot-password :class="{active: mode === 'forgot_password'}"></auth-forgot-password>
    </div>
  </div>
</template>

<script>
import AuthLogin from './Login'
import AuthSignup from './Signup'
import AuthForgotPassword from './ForgotPassword'

export default {
  components: {
    AuthLogin,
    AuthSignup,
    AuthForgotPassword
  },

  data () {
    return {
      mode: 'login'
    }
  },

  computed: {
    navItems () {
      return [
        { id: 'login', label: 'Sign In' },
        { id: 'signup', label: 'Join' },
      ]
    },
  },

  methods: {
    changeAuthMode (which) {
      this.mode = which.id
    }
  }
}

</script>
